import styled from "styled-components";

export const DotContainer = styled.div`
  width: 100%;
  height: auto;

  position: absolute;
  left: 0;
  bottom: 25px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
`;
